import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import "./navbar.css";
import logo from '../images/logo1.png'

export default function Navbar() {

  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;


  const toggleMenu = (value) => {
    if (value === "logo") {
      setIsOpen(false)
    } else {
      setIsOpen(!isOpen);
    }

  };

  useEffect(() => {

    if (isOpen && !isDesktop) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const navigate = useNavigate();

  const goToHome = () => {
    toggleMenu("logo")
    navigate('/');
  };

  const goToAboutUs = () => {
    navigate('/aboutUs');
  };

  const goToOurValues = () => {
    navigate('/ourValues');
  };

  const goToContactUs = () => { // TODO : add a contact us page
    navigate('/meetOurFamily');
  };


  return (
    <nav className="navbar">
      <div className="logo" onClick={goToHome}>
        <div className='tooltip-container'>
          <img src={logo} className='logo-navbar' />
          <span className="tooltip-text">Bandara Motoren</span>
        </div>
        {/* <div className='bandara'>Bandara</div>
        <div className='motoren'>Motoren</div> */}
      </div>

      <div className={`hamburger ${isOpen ? 'open' : ''}`} id="hamburger-1" onClick={toggleMenu}>
        <span class="bar"></span>
        <span class="bar bar-middle"></span>
        <span class="bar"></span>
      </div>

      <ul className={`nav-links ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <li><Link to="/#introVideo">Intro video</Link></li>
        <li><Link to='/aboutUs'>About us</Link></li>
        <li><Link to='/ourValues' >Our values</Link></li>
        <li><Link to='/contactUs'>Contact us</Link></li>
      </ul>
    </nav>
  );
}
